"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnparsedIncomeReportReason = void 0;
/* @TranslateToPython */
var UnparsedIncomeReportReason;
(function (UnparsedIncomeReportReason) {
    // The report carried no payload at all, so there was nothing to parse.
    UnparsedIncomeReportReason["REPORT_MISSING"] = "REPORT_MISSING";
    // The payload could not be read in any shape the parser understands.
    UnparsedIncomeReportReason["UNREADABLE_REPORT"] = "UNREADABLE_REPORT";
    // The report declares a document type the parser does not support.
    UnparsedIncomeReportReason["UNSUPPORTED_DOCUMENT_TYPE"] = "UNSUPPORTED_DOCUMENT_TYPE";
    // The parser raised while reading the report.
    UnparsedIncomeReportReason["PARSE_ERROR"] = "PARSE_ERROR";
    // A Plaid sub-report carries no items, or an item with no accounts, so it holds nothing to read.
    UnparsedIncomeReportReason["PLAID_ITEMS_MISSING"] = "PLAID_ITEMS_MISSING";
    // A Plaid sub-report has neither institution_id nor institution_name, so its accounts cannot be de-duplicated.
    UnparsedIncomeReportReason["INSTITUTION_IDENTIFIER_MISSING"] = "INSTITUTION_IDENTIFIER_MISSING";
    // Every account a Plaid sub-report lists is already counted from an earlier report, so it adds nothing.
    UnparsedIncomeReportReason["DUPLICATE_REPORT"] = "DUPLICATE_REPORT";
    // The sub-report does not say which document type it is.
    UnparsedIncomeReportReason["DOCUMENT_TYPE_MISSING"] = "DOCUMENT_TYPE_MISSING";
    // The sub-report carries no response payload to read, or a manual verification carries no manually verified income.
    UnparsedIncomeReportReason["REPORT_CONTENT_MISSING"] = "REPORT_CONTENT_MISSING";
    // A tax document carries no year, so it cannot be placed in a tax period.
    UnparsedIncomeReportReason["TAX_YEAR_MISSING"] = "TAX_YEAR_MISSING";
    // A tax document's year is not a number.
    UnparsedIncomeReportReason["TAX_YEAR_INVALID"] = "TAX_YEAR_INVALID";
    // A paystub carries no earnings subtotals.
    UnparsedIncomeReportReason["PAYSTUB_EARNINGS_MISSING"] = "PAYSTUB_EARNINGS_MISSING";
    // A paystub's earnings subtotals use no earning description the parser knows.
    UnparsedIncomeReportReason["PAYSTUB_EARNINGS_UNRECOGNIZED"] = "PAYSTUB_EARNINGS_UNRECOGNIZED";
    // A paystub has no usable pay period start and end.
    UnparsedIncomeReportReason["PAYSTUB_PAY_PERIOD_MISSING"] = "PAYSTUB_PAY_PERIOD_MISSING";
    // A manually verified paystub carries no paystub metadata.
    UnparsedIncomeReportReason["PAYSTUB_METADATA_MISSING"] = "PAYSTUB_METADATA_MISSING";
    // A W-2 carries neither wages nor Medicare wages.
    UnparsedIncomeReportReason["W2_WAGES_MISSING"] = "W2_WAGES_MISSING";
    // A 1040 carries no address, which the parser requires to treat it as a read form.
    UnparsedIncomeReportReason["FORM_1040_ADDRESS_MISSING"] = "FORM_1040_ADDRESS_MISSING";
    // An SSA-1099 carries no net benefits amount.
    UnparsedIncomeReportReason["FORM_SSA_1099_NET_BENEFITS_MISSING"] = "FORM_SSA_1099_NET_BENEFITS_MISSING";
    // A 1099-R carries no gross distribution amount.
    UnparsedIncomeReportReason["FORM_1099_R_GROSS_DISTRIBUTION_MISSING"] = "FORM_1099_R_GROSS_DISTRIBUTION_MISSING";
    // The IRS form markup is readable but no income field could be extracted from it.
    UnparsedIncomeReportReason["TAX_FORM_FIELDS_MISSING"] = "TAX_FORM_FIELDS_MISSING";
    // WorkNumber returned no employment records.
    UnparsedIncomeReportReason["EMPLOYMENTS_MISSING"] = "EMPLOYMENTS_MISSING";
    // An active WorkNumber employment yielded no income document.
    UnparsedIncomeReportReason["EMPLOYMENT_INCOME_MISSING"] = "EMPLOYMENT_INCOME_MISSING";
    // The manual verification does not say which applicant the document belongs to.
    UnparsedIncomeReportReason["INCOME_RECIPIENT_MISSING"] = "INCOME_RECIPIENT_MISSING";
})(UnparsedIncomeReportReason || (exports.UnparsedIncomeReportReason = UnparsedIncomeReportReason = {}));
